import YouTube from "@quarkly/community-kit/YouTube";
export default YouTube;